import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  DEVICE_STATUS,
  OPP_CONSTANTS,
  ORDER_STATUS,
} from "../../constants/OppContants";
import ModelPopup from "./ModelPopup";
import { QC_VALIDATIONS } from "../../constants/Actions";
import { Card } from "antd";

const CertificateComponent = ({
  isAtDevice,
  isForSDCard,
  status,
  deviceDefaultStatus,
  deviceStatus,
}) => {
  const [modalState, setModalState] = useState(false);
  const [certificateStatus, setCertificateStatus] = useState({
    title: "Device Status",
    icon: "file-circle-check",
    color: "gray",
    isDisabled: true,
    statusMessage: null,
  });

  const [statusMap, setStatusMap] = useState([]);

  // default  & current value
  useEffect(() => {
    let status = deviceDefaultStatus ?? [];
    if (isAtDevice) {
      if (deviceStatus) {
        status = deviceStatus ?? [];
      }
      updateStatusMap(status);
    }
  }, [isAtDevice, deviceStatus, deviceDefaultStatus]);

  const updateStatusMap = (status) => {
    let finalStatusMap = QC_VALIDATIONS.map((obj1) => {
      // Find the matching object from object2
      const obj2 = status.find((obj) => obj.actionId === obj1.id);

      // If a matching object is found, merge their properties
      return obj2 ? { ...obj1, ...obj2 } : { ...obj1 };
    });

    if (JSON.stringify(finalStatusMap) !== JSON.stringify(statusMap)) {
      setStatusMap(finalStatusMap);
    }
  };

  useEffect(() => {
    if (statusMap && statusMap.length > 0) {
      updateActionStatus();
    }
  }, [statusMap]);

  const updateActionStatus = () => {
    var updateCertificateStatus = {
      title: "Device Status",
      icon: "file-circle-check",
      color: "gray",
      isDisabled: true,
      statusMessage: null,
    };
    var actionsSummary = "";
    if (statusMap[0].status) {
      updateCertificateStatus.isDisabled = false;
      if (
        statusMap[0].status.toUpperCase() ===
        DEVICE_STATUS.SUCCESS.toUpperCase()
      ) {
        updateCertificateStatus.color = "green";
      }
    }

    if (isForSDCard && statusMap[8].status) {
      updateCertificateStatus.isDisabled = false;
      if (
        statusMap[8].status.toUpperCase() ===
        DEVICE_STATUS.SUCCESS.toUpperCase()
      ) {
        updateCertificateStatus.color = "green";
      }
    }

    statusMap.map((actionData) => {
      switch (actionData.id) {
        case "DISPLAY_MESSAGE":
          break;
        default:
          if (actionData.status) {
            var myActionSummary = (
              <div>
                <strong> {actionData.displayTitle}:</strong>
                <br />
                &emsp;status:
                <span
                  style={{
                    color:
                      actionData.status?.toUpperCase() ===
                      DEVICE_STATUS.SUCCESS?.toUpperCase()
                        ? "green"
                        : "red",
                  }}
                >
                  <strong> {actionData.status} </strong>
                </span>
                <br />
                &emsp;summary:
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      actionData?.summary ??
                      ""
                        .replace(/Validating/, "Validated")
                        .replace(/<div/, `<div style="margin-left: 40px;"`),
                  }}
                />
              </div>
            );

            actionsSummary = (
              <p style={{ lineHeight: "1.6" }}>
                {actionsSummary}
                {myActionSummary}
              </p>
            );
            if (
              actionData.status.toUpperCase() ===
              DEVICE_STATUS.FAILURE.toUpperCase()
            ) {
              updateCertificateStatus.color = "red";
            }
          }
          break;
      }
    });

    updateCertificateStatus.statusMessage = (
      <Card size="small" style={{ marginTop: "20px" }}>
        <p style={{ lineHeight: "1.6" }}>{actionsSummary}</p>
      </Card>
    );
    setCertificateStatus(updateCertificateStatus);
  };

  useEffect(() => {
    if (status) {
      updateCertificateStatus();
    }
  }, [status]);

  const updateCertificateStatus = () => {
    setCertificateStatus({
      title: status?.title ?? "Device Status",
      icon: status.icon ?? "file-circle-check",
      color:
        !status?.status ||
        (status?.status &&
          status?.status?.toUpperCase() ===
            ORDER_STATUS.INPROGRESS.toUpperCase())
          ? "gray"
          : !status.remarks &&
            status?.status &&
            status?.status?.toUpperCase() ===
              DEVICE_STATUS.SUCCESS.toUpperCase()
          ? "green"
          : "red",
      isDisabled:
        status?.status == null ||
        status?.status == undefined ||
        status?.status?.toUpperCase() === ORDER_STATUS.INPROGRESS.toUpperCase(),
      statusMessage:
        status?.summary && status?.summary instanceof Object ? (
          status?.summary
        ) : status?.summary &&
          (typeof status?.summary === "string" ||
            status?.summary instanceof String) ? (
          <div dangerouslySetInnerHTML={{ __html: status?.summary }} />
        ) : (
          "NA"
        ),
    });
  };

  const handleOnClick = () => {
    if (!certificateStatus.isDisabled) {
      setModalState(true);
    }
  };

  const handleClose = () => {
    setModalState(false);
  };

  return (
    <div
      style={{
        width: "85px",
        alignSelf: "center",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <FontAwesomeIcon
        icon={"file-circle-check"}
        color={certificateStatus?.color}
        size="2x"
        onClick={handleOnClick}
      />

      <div style={{ position: "absolute" }}>
        <ModelPopup
          show={modalState}
          iconName={certificateStatus.icon}
          iconColor={certificateStatus.color}
          title={certificateStatus.title}
          okTitle={OPP_CONSTANTS.btns.close}
          handleOkClick={handleClose}
          hasInput={false}
          placeholder={certificateStatus.statusMessage}
          handleClose={handleClose}
        />
      </div>
    </div>
  );
};

export default CertificateComponent;
